import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodePartnerTeaserSmallProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

interface LogoProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  logo?: string;
  title: string;
}

const Logo: React.FC<LogoProps> = ({ logo, title }) => (
  <>
    {logo && (
      <div className="NodePartnerTeaserSmall__logo">
        <Image src={logo} alt={title} />
      </div>
    )}
  </>
);

const NodePartnerTeaserSmall: React.FC<NodePartnerTeaserSmallProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodePartnerTeaserSmall');
  const partner = entity.toJS();
  const title = partner.title[0].value;
  const logo = partner.field_media_item[0]?.styles?.original;
  const url = partner.field_link[0]?.alias;

  return (
    <div className="col-6 col-sm-4 col-md-3 col-lg-2">
      <div className={classes}>
        {url ? (
          <CoreLink href={url}>
            <Logo
              logo={logo}
              title={title}
            />
          </CoreLink>
        ) : (
          <Logo
            logo={logo}
            title={title}
          />
        )}
      </div>
    </div>
  );
};

export default NodePartnerTeaserSmall;
